import React from 'react';
import { classes } from '@components/CreativeLibrary/styles';
import {
  Grid,
  Typography,
} from '@mui/material';
import { useDomain } from '@hooks/domain';
import { useCreativeLibrary } from '@components/CreativeLibrary/CreativeLibraryContext';
import { useFlags as useLDFlags } from 'launchdarkly-react-client-sdk';
import { CreativeStatusDisplayNames, DefaultCreativeStatusKeys } from '@constants/status';
import { StatusSelect } from '@components/StatusSelect';

export const CreativeLibraryHeader = () => {
  const domain = useDomain();
  const {
    statuses,
    setStatuses,
  } = useCreativeLibrary();
  const { hcmReleaseFilterCreativeLibraryByStatus } = useLDFlags();

  return (
    <Grid
      className={classes.libraryHeader}
      container
      alignItems="center"
      justifyContent="space-between"
    >
      <Grid item xs={6}>
        <Typography variant="h2">Creative</Typography>

        {domain.peacock && (
          <p>
            Select the checkbox next to a previously saved creative to assign
            it to your campaign.
          </p>
        )}
      </Grid>

      <Grid
        container
        item
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
        xs={6}
      >
        <Grid
          item
          xs={12}
          sx={{ display: 'flex', justifyContent: 'flex-end' }}
        >
          {hcmReleaseFilterCreativeLibraryByStatus && (
            <StatusSelect
              regularStatuses={DefaultCreativeStatusKeys}
              statusDisplayNames={CreativeStatusDisplayNames}
              chosenStatuses={statuses}
              onChange={setStatuses}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
